import { Box, Stack, Button, Typography, Snackbar, Alert } from "@mui/material";
import { AccountCircle, NavigateNext } from "@mui/icons-material";
import { useEffect, useState } from "react";
import api from "../services/api";
import { ErrorMessageServeDefault } from "../utils/mensagensSistema";

import { useNavigate } from "react-router-dom";

const styles = {
  title: {
    fontWeight: "300",
    fontSize: "32px",
    lineHeight: "25px",
    color: "#063F5E",
  },
  subtitle: {
    fontWeight: "500",
    fontSize: "22px",
    lineHeight: "30px",
    marginBottom: "2px",
    color: "#1E729F",
    fontFamily: "Ninuto, sans-serif !important",
  },
  diamond: {
    fill: "#1E729F",
  },
  typeStrong: {
    fontFamily: "Ninuto, sans-serif !important",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "22px",
    letterSpacing: "0em",
    textAlign: "left",
    marginRight: "8px",
    color: "#333333 !important",
    whiteSpace: "nowrap",
  },
  text: {
    fontFamily: "Ninuto, sans-serif !important",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px",
    letterSpacing: "0em",
    color: " #737373 !important",
  },
};

const LabelContainer = ({ text, strong }) => (
  <Box component="div" sx={{ display: "flex" }}>
    <Typography component="strong" sx={{ ...styles.typeStrong }}>
      {strong}
    </Typography>
    <Typography component="p" sx={{ ...styles.text }}>
      {text}
    </Typography>
  </Box>
);

export default function CardPaciente({ id, callback }) {
  const navigate = useNavigate();
  const [paciente, setPaciente] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getDadosPaciente();
  }, [id]);

  async function getDadosPaciente() {
    try {
      setLoading(true);
      const { data } = await api.get(`/dadospaciente/${id}`);

      if (data.status === "Error") {
        setError({
          children: `Error: Paciente com o id: ${id} não encontrado.`,
          severity: "error",
        });
      } else {
        setPaciente(data);
      }
    } catch (error) {
      setError({
        children: ErrorMessageServeDefault,
        severity: "error",
      });
      console.error("Ocorreu um erro:", error.message);
    } finally {
      setLoading(false);
    }
  }

  function openDetalhes() {
    navigate(`/pacientes/detalhes-cadastro/${id}`);
  }

  return (
    <>
      {!loading && (
        <Box
          sx={{
            boxShadow: "0px 1px 8px 0px #00000026",
            boxSizing: "border-box !important",
            padding: "30px 24px",
            margin: "16px 0px",
            borderRadius: "8px",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "16px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "16px 7px",
              }}
            >
              <AccountCircle
                fontSize="large"
                sx={{
                  width: "50px",
                  height: "50px",
                  boxSizing: "border-box !important",
                }}
              />
              <Stack>
                <Typography
                  sx={{ ...styles.subtitle, textTransform: "uppercase" }}
                >
                  {paciente.nome}
                </Typography>
                <Box display="flex" gap="8px 16px" flexWrap="wrap">
                  <LabelContainer strong="CPF:" text={paciente.cpf} />
                  <LabelContainer strong="CNS:" text={paciente.cns} />
                </Box>
              </Stack>
            </Box>
            <Box display="flex" justifyContent="flex-end">
              <Button
                onClick={() => openDetalhes()}
                sx={{
                  width: "fit-content",
                  height: "fit-content",
                  textTransform: "none",
                  alignItems: "flex-end",
                }}
                variant="outlined"
              >
                Detalhes do cadastro <NavigateNext />
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              boxSizing: "border-box !important",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "16px",
              mt: "16px",
            }}
          >
            <LabelContainer strong="Idade:" text={`${paciente.idade} anos`} />
            <LabelContainer strong="Sexo:" text={paciente.genero} />
            <LabelContainer strong="Raça/Cor:" text={paciente.racaCor} />
            <LabelContainer
              strong="Naturalidade:"
              text={paciente?.naturalidade?.descricao ?? ""}
            />
            <LabelContainer
              strong="Cidade de residência:"
              text={paciente.cidadeResidencia}
            />
            <LabelContainer strong="Estado:" text={paciente.estadoResidencia} />
          </Box>
          {!!error && (
            <Snackbar
              open
              onClose={() => {}}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert {...error} onClose={() => setError(null)} />
            </Snackbar>
          )}
        </Box>
      )}
    </>
  );
}
